<template>
  <div>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text"><strong>003sm</strong></span>
      </div>
      <template v-for="(cond, i) in conditions">
        <div :class="{'input-group-prepend': true, green: cond.class === 'green', blue: cond.class === 'blue'}">
          <span class="input-group-text">{{ cond.title }}</span>
        </div>
        <div v-if="cond.condition">
          <select v-model="cond.condition" class="form-control">
            <option value="more">></option>
            <option value="less"><</option>
          </select>
        </div>
        <input v-model="cond.value" type="number" placeholder="..0" class="form-control min_input">
        <div v-if="i < (conditions.length - 1)">
          <select v-model="joinCondition" class="form-control">
            <option value="and"> и</option>
            <option value="or"> или</option>
          </select>
        </div>
      </template>
      <div class="remove_btn input-group-prepend">
        <button @click="removeTask()" :disabled="deleteLoading" class="btn btn-default" v-if="task?.id">
          <i class="icon-fa icon-fa-trash-o" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['task', 'onDelete'],
  data() {
    return {
      toDelete: false,
      deleteLoading: false,
      joinCondition: 'or',
      conditions: [
        {title: 'цена', alias: 'price', condition: 'more', value: '', class: 'green'},
        {title: 'наличие', alias: 'store', condition: 'more', value: '', class: 'blue'},
        {title: 'спрос', condition: 'more', alias: 'call', value: ''},
      ]
    }
  },
  watch: {
    'conditions': {
      handler: function (val, oldVal) {
        this.toDelete = false;
      },
      deep: true
    },
  },
  created() {
    if (this.task) {
      this.conditions = this.conditions.reduce((acc, c, i) => {
        acc.push({...c, ...this.task.task_data.conditions[i]})
        return acc;
      }, []);
      this.joinCondition = this.conditions[0].joinCondition;
    }
  },
  methods: {
    removeTask() {
      Object.keys(this.conditions).forEach((k) => {
        this.conditions[k].value = '';
      })
      setTimeout(() => {
        this.toDelete = true;
        if (this.onDelete) {
          this.deleteLoading = true;
          this.onDelete(this.task.id);
        }
      }, 100)
    }
  }
}

</script>

<style scoped>
select {
  border-radius: 0;
}

.input-group-prepend.blue span {
  background-color: #9ccaff;
}

.min_input {
  min-width: 70px;
}

.input-group-prepend.green span {
  background-color: #00e400;
}
</style>
